import React, { useMemo } from "react";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function PlannerHeader({
  view,
  focusDate,
  currentMonth,
  onBack,
  onNavigate,
  selectedUser,
  isTeamView,
}) {
  const title = useMemo(() => {
    if (view === "month") {
      return `${MONTH_NAMES[currentMonth.month - 1]} ${currentMonth.year}`;
    }

    if (view === "day" && isTeamView) {
      return focusDate.toLocaleDateString("en-IN", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    return focusDate.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }, [view, focusDate, currentMonth, isTeamView]);

  return (
    <div className="planner-header">
      <div className="planner-header-title">
        <h2>{view === "month" ? "Planner" : title}</h2>
        <span className="planner-view-label">
          {isTeamView
            ? view === "day"
              ? "Team \u00B7 day view"
              : "Team view"
            : selectedUser
              ? `${selectedUser.firstName} ${selectedUser.lastName}`
              : "Personal view"}
          {view !== "month" && !isTeamView && ` \u00B7 ${view} view`}
        </span>
      </div>
      <div className="planner-header-actions">
        {view !== "month" && (
          <button className="planner-nav-btn" onClick={onBack}>
            Back
          </button>
        )}
        <button className="planner-nav-btn" onClick={() => onNavigate(-1)}>
          &larr;
        </button>
        <span className="planner-view-label">
          {MONTH_NAMES[currentMonth.month - 1]} {currentMonth.year}
        </span>
        <button className="planner-nav-btn" onClick={() => onNavigate(1)}>
          &rarr;
        </button>
      </div>
    </div>
  );
}
